module.exports = __webpack_public_path__ + "img/invoiceSet.cd92f4d6.png";